<form [formGroup]="aFormGroup">
	<ngx-recaptcha2 [siteKey]="siteKey" (reset)="onReset()" (expire)="onExpire()" (load)="onLoad()"
		(success)="onSuccess($event)" formControlName="recaptcha">
	</ngx-recaptcha2>
</form>